<template>
  <div class="card accompagnement-card h-100 shadow-sm">
    <div class="card-img-top-wrapper">
      <img
        src="@/assets/img/photo/perte-memoire-personnes-agees.jpg"
        class="card-img-top"
        :alt="$t('persAgeResume.image.alt')"
      />
    </div>

    <div class="card-body d-flex flex-column">
      <h5 class="fw-bold" style="font-size: 1.3rem">
        {{ $t("persAgeResume.title") }}
      </h5>

      <p class="text-muted" style="font-size: 1rem; line-height: 1.4">
        {{ $t("persAgeResume.text.p1") }}
      </p>

      <a
        href="/personnes-agees-troubles-cognitifs"
        class="btn btn-custom mt-2 w-100 mt-auto"
      >
        {{ $t("persAgeResume.button.more") }}
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "PersAgeResume",
};
</script>

<style></style>
